import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { cn } from '@shigo-ui/ui/cn';

import { ShigoPermission } from '../../../auth/permissions';
import { useShigoPermissions } from '../../../auth/useShigoPermissions';
import { dashboardT } from '../../../../lib/messages';

export function SupplyAppsLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { can } = useShigoPermissions();
  const tabs = [
    can(ShigoPermission.SupplyAppsInventoryRead)
      ? { to: '/supply/apps' as const, label: dashboardT('supplyApps.tabs.apps') }
      : null,
    can(ShigoPermission.SupplyAppRequestsRead)
      ? { to: '/supply/apps/requests' as const, label: dashboardT('supplyApps.tabs.requests') }
      : null,
  ].filter((tab): tab is NonNullable<typeof tab> => tab !== null);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <nav
        aria-label={dashboardT('nav.supply.apps')}
        className="border-border bg-card page-gutter shrink-0 border-b"
      >
        <div className="flex min-w-max gap-1 overflow-x-auto">
          {tabs.map((tab) => {
            const active =
              tab.to === '/supply/apps'
                ? pathname === '/supply/apps' || pathname === '/supply/apps/'
                : pathname.startsWith(tab.to);
            return (
              <Link
                key={tab.to}
                to={tab.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                  active && 'shigo-supply-tab--active',
                )}
              >
                {tab.label}
              </Link>
            );
          })}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
